__turbopack_context__.v({
  "chevronArrow": "index-module___gIoGW__chevronArrow",
  "claimFadeIn": "index-module___gIoGW__claimFadeIn",
  "claimSlideUp": "index-module___gIoGW__claimSlideUp",
  "closeButton": "index-module___gIoGW__closeButton",
  "closeButtonDefault": "index-module___gIoGW__closeButtonDefault",
  "closeButtonHero": "index-module___gIoGW__closeButtonHero",
  "closeIcon": "index-module___gIoGW__closeIcon",
  "ctaLink": "index-module___gIoGW__ctaLink",
  "ctaLinkMobileOnly": "index-module___gIoGW__ctaLinkMobileOnly",
  "ctaRow": "index-module___gIoGW__ctaRow",
  "heroImageWrap": "index-module___gIoGW__heroImageWrap",
  "kitImage": "index-module___gIoGW__kitImage",
  "kitImageDefault": "index-module___gIoGW__kitImageDefault",
  "kitImageFull": "index-module___gIoGW__kitImageFull",
  "overlay": "index-module___gIoGW__overlay",
  "popupBody": "index-module___gIoGW__popupBody",
  "popupCard": "index-module___gIoGW__popupCard",
  "popupCardDefault": "index-module___gIoGW__popupCardDefault",
  "popupCardHero": "index-module___gIoGW__popupCardHero",
  "primaryCta": "index-module___gIoGW__primaryCta",
  "subtitle": "index-module___gIoGW__subtitle",
  "title": "index-module___gIoGW__title",
  "typeformContainer": "index-module___gIoGW__typeformContainer",
  "typeformModal": "index-module___gIoGW__typeformModal",
});
